<script>
import Vue from "vue";
import Validatable from "./Validatable.vue";
import Maskable from "./Maskable.vue";
import InputProps from "./InputProps.vue";

export default Vue.extend({
  mixins: [InputProps, Validatable, Maskable],
  created() {
    this.defineProp(this.name);
  },
  methods: {
    defineProp(propName) {
      if (propName && this.formData) {
        const formValue = this.formData[propName];
        if (
          !Object.prototype.hasOwnProperty.call(this.formData, propName) ||
          !formValue
        ) {
          Vue.set(this.formData, propName, this.value);
        }
      }
    },
  },
});
</script>
